/**
 * @desc Yung-取消入库单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.InMasterCancelRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/inMaster/cancelInMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
